import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import login from '@/components/login'
import home from '@/components/home'
import activity from '@/components/list/activity'
import draft from '@/components/list/index'
import detail from '@/components/list/detail'
import reports from '@/components/list/reports'
import upload from '@/components/list/upload'
import send from '@/components/list/send'
import jd from '@/components/list/jd'
import setting from '@/components/list/setting'
import accounteg from '@/components/accounteg'
import pay from '@/components/pay'
import create from '@/components/list/create'
import downhis from '@/components/list/downhis'
import votes from '@/components/list/votes'


import operate from '@/pages/operate'
import activitys from '@/pages/activitys'
import members from '@/pages/members'
import notice from '@/pages/notice'

import checkout from '@/pages/checkout'
import buyTraffic from '@/pages/buyTraffic'
import buyVip from '@/pages/buyVip'
import packDown from '@/pages/packDown'
import produce from '@/pages/produce'
import cooperate from '@/pages/cooperate'
import resultQueryIndex from '@/pages/resultQuery/index'
import resultQueryUpdate from '@/pages/resultQuery/update'
import tools from '@/pages/tools/tools'
import toolsActivity from '@/pages/tools/activity'
import toolsDownTraffic from '@/pages/tools/down-traffic'
import toolsPinnedActivity from '@/pages/tools/pinned-activity'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/produce',
      name: 'produce',
      component: produce
    },
    {
      path: '/cooperate',
      name: 'cooperate',
      component: cooperate
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      redirect:{
        path:'/home/activity'
      },
      children:[
        {
          path:'/home/activity',
          name:'activity',
          component: activity,
          redirect:{
            path:'/home/activity/index'
          },
          children:[
            {
              path:'/home/activity/index',
              name:'draft',
              component: draft,
              meta: {
                 keepAlive: true, //此组件需要被缓存
              },
            },
            {
              path:'/home/activity/detail/:id',
              name:'detail',
              component: detail,
            },
          ]
        },
        {
          path:'/home/reports',
          name:'reports',
          component: reports,
          meta: {
            keepAlive: true, //此组件需要被缓存
          },
        },
        {
          path:'/home/downhis',
          name:'downhis',
          component: downhis,
        },
        {
          path:'/home/votes',
          name:'votes',
          component: votes,
        },
        {
          path:'/home/upload',
          name:'upload',
          component: upload,
        },
        {
          path:'/home/send',
          name:'send',
          component: send,
        },
        {
          path:'/home/jd',
          name:'jd',
          component: jd,
        },
        {
          path:'/home/create',
          name:'create',
          component: create,
        },
        {
          path:'/home/setting',
          name:'setting',
          component: setting,
        },
        {
          path:'/home/resultQuery/index',
          name:'resultQueryIndex',
          component: resultQueryIndex,
        },
        {
          path:'/home/resultQuery/update',
          name:'resultQueryUpdate',
          component: resultQueryUpdate,
        },
      ]
    },
    {
      path:'/accounteg',
      name:'accounteg',
      component: accounteg,
    },
    {
      path:'/pay',
      name:'pay',
      component: pay,
    },
    {
      path:'/operate',
      name:'operate',
      component: operate,
      redirect:{
        path:'/operate/activitys'
      },
      children:[
        {
          path:'/operate/activitys',
          name:'activitys',
          component: activitys,
        },
        {
          path:'/operate/members',
          name:'members',
          component: members,
        },
        {
          path:'/operate/notice',
          name:'notice',
          component: notice,
        },
      ],
    },
    {
      path:'/checkout',
      name:'checkout',
      component: checkout,
      redirect:{
        path:'/checkout/buyVip'
      },
      children:[
        {
          path:'/checkout/buyVip',
          name:'buyVip',
          component: buyVip,
        },
        {
          path:'/checkout/buyTraffic',
          name:'buyTraffic',
          component: buyTraffic,
        },
        {
          path:'/checkout/packDown',
          name:'packDown',
          component: packDown,
        },
      ],
    },
    {
      path: '/tools',
      name: 'tools',
      component: tools,
      children:[
        {
          path:'/tools/activity/:options/:tmp?',
          name:'tools-activity',
          component: toolsActivity,
        },
        {
          path:'/tools/down-traffic/:options/:tmp?',
          name:'tools-down-traffic',
          component: toolsDownTraffic,
        },
        {
          path:'/tools/pinned-activity/:options/:tmp?',
          name:'tools-pinned-activity',
          component: toolsPinnedActivity,
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js